// react
import React from 'react';

// tanstack
import { createLink } from '@tanstack/react-router';

// material ui
import { Link } from '@mui/material';

const MUILinkComponent = React.forwardRef((props, ref) => (
  <Link ref={ref} {...props} />
));

MUILinkComponent.displayName = 'MUILinkComponent';

const CreatedLinkComponent = createLink(MUILinkComponent);

export const CustomLink = (props) => {
  return <CreatedLinkComponent preload="intent" {...props} />;
};
